import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, toRefs } from 'vue'
import useGlobal from '@/composables/useGlobal'

export default /*#__PURE__*/_defineComponent({
  __name: 'Autocomplete',
  props: {
  options: {
    default: {},
  },
  modelValue: {
    default: '',
  },
  value: {
    default: '',
  },
  modelTarget: {
    default: 'name'
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();


const { $t } = useGlobal()
const props = __props

const { modelValue } = toRefs(props)
const emit = __emit
const val = ref(modelValue.value)

watch(() => modelValue.value, (nval, oval) => {
  if (oval === nval) return
  val.value = nval
}, { immediate: true })

const google = ref(null)
const autocompleteInput = ref(null)
const autocomplete: any = ref(null)
const apiKey = ref(window.google_map_api_key)

const loadScript = () => {
  // if (window.initAutocomplete) return
  window.initAutocomplete = initAutocomplete;
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey.value}&libraries=places&callback=initAutocomplete`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  };

function initAutocomplete() {
  google.value = window.google;
  autocomplete.value = new google.value.maps.places.Autocomplete(autocompleteInput.value, { apiKey: apiKey.value, ...props.options })
  autocomplete.value.addListener('place_changed', getPlaceValue)
}

function getPlaceValue () {
  const place = autocomplete.value.getPlace()
  emit("update:modelValue", place[props.modelTarget])
}

const setValue = e => {
  if (e.target.validity.badInput) return
  const v = e.target.value
  emit("update:modelValue", v)
}
onMounted( () => {
  if (apiKey.value && !window.initAutocomplete) loadScript()
})

const __returned__ = { $t, props, modelValue, emit, val, google, autocompleteInput, autocomplete, apiKey, loadScript, initAutocomplete, getPlaceValue, setValue, ref, onMounted, watch, toRefs, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})